import { Link } from "react-router-dom";
import { Picture } from "@/components/Picture";

const HashLink = ({ onHome, hash, children, ...rest }) =>
  onHome ? (
    <a href={`#${hash}`} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={`/#${hash}`} {...rest}>
      {children}
    </Link>
  );

export const Header = ({ current, summitOn }) => {
  const onHome = current === "home";
  return (
    <header className="site-header">
      <div className="wrap">
        <Link className="brand" to="/" aria-label="Nepal Food Networks, home" data-testid="header-brand-link">
          <Picture src="/assets/img/mark-green.png" alt="" />
          <span>
            Nepal Food Networks<small>Grow, prepare, share</small>
          </span>
        </Link>
        <nav className="nav" aria-label="Main">
          <Link
            to="/"
            className="hide-sm"
            aria-current={current === "home" ? "page" : undefined}
            data-testid="nav-home-link"
          >
            Home
          </Link>
          <Link
            to="/our-story"
            className="hide-sm"
            aria-current={current === "story" ? "page" : undefined}
            data-testid="nav-our-story-link"
          >
            Our story
          </Link>
          {summitOn && (
            <HashLink onHome={onHome} hash="summit" className="hide-sm" data-testid="nav-summit-link">
              Summit 2026
            </HashLink>
          )}
          <HashLink onHome={onHome} hash="join" className="btn" data-testid="nav-join-button">
            Join
          </HashLink>
        </nav>
      </div>
    </header>
  );
};
